'use strict'

import * as BasUtil from '@basalte/bas-util'

angular
  .module('basalteApp')
  .controller('sonosSettingsCtrl', [
    '$rootScope',
    '$scope',
    'SETTINGS_STATES',
    'BAS_CURRENT_CORE',
    'BAS_MODAL',
    'CurrentBasCore',
    'BasModal',
    'BasInAppBrowser',
    sonosSettingsController
  ])

/**
 * @param $rootScope
 * @param $scope
 * @param SETTINGS_STATES
 * @param BAS_CURRENT_CORE
 * @param BAS_MODAL
 * @param {CurrentBasCore} CurrentBasCore
 * @param {BasModal} BasModal
 * @param BasInAppBrowser
 */
function sonosSettingsController (
  $rootScope,
  $scope,
  SETTINGS_STATES,
  BAS_CURRENT_CORE,
  BAS_MODAL,
  CurrentBasCore,
  BasModal,
  BasInAppBrowser
) {
  const sonos = this

  /**
   * @type {BasInAppBrowser | null}
   */
  let inAppBrowserWindow = null
  const listeners = []

  /**
   * @type {TCurrentBasCoreState}
   */
  sonos.currentBasCoreState = CurrentBasCore.get()
  sonos.SETTINGS_STATES = SETTINGS_STATES

  sonos.pair = () => {
    const url = sonos.currentBasCoreState.core?.basServer?.host
      ?.getHTTPUrl('api/oauth/sonos/link')

    if (!url) return

    inAppBrowserWindow?.closeInAppBrowser()
    inAppBrowserWindow = new BasInAppBrowser(url)
  }

  sonos.unpair = async () => {
    const modal = await BasModal.show(BAS_MODAL.T_UNLINK_SONOS)
    const result = await modal.closed

    if (result === BAS_MODAL.C_YES) {
      sonos.currentBasCoreState.core?.core?.system.unlinkSonos()
    }
  }

  init()

  function init () {
    listeners.push($rootScope.$on(
      BAS_CURRENT_CORE.EVT_CORE_SYSTEM,
      () => $rootScope.$applyAsync()
    ))
    $scope.$on('$destroy', () => BasUtil.executeArray(listeners))
  }
}
